export default {
    accountOrPasswordError: "O nome da conta ou senha é um erro",
    noAuth: "Nenhuma permissão no momento, entre em contato com o pessoal de atendimento ao cliente!"
}